import { z } from 'zod';
import { UserType } from '../enums.js';
import { emailSchema } from './email.js';
import { passwordSchema } from './password.js';

export const signUpSchema = z
  .object({
    email: emailSchema(),
    password: passwordSchema,
    confirm_password: z.string().min(1),
    type: z.enum(UserType),
  })
  .refine((data) => data.password === data.confirm_password, {
    message: 'Passwords do not match',
    path: ['confirm_password'],
  });

export type SignUpPayload = z.infer<typeof signUpSchema>;
